import React from 'react';

import FiltersRefinementContentItem from '../FiltersRefinementContentItem';

import {IFiltersRefinementContentColorDataProps} from './IFiltersRefinementContentColorData';

import styles from './FiltersRefinementContentColorData.module.scss';

const FiltersRefinementContentColorData = ({refinement}: IFiltersRefinementContentColorDataProps) => {
	if (!refinement) {
		return null;
	}

	const classNames = {
		checkbox: styles['filters-refinement__swatch-color'],
		input: styles['filters-refinement__input-color'],
		label: styles['filters-refinement__label-color']
	};

	const specialColorSwatchesWithBorder = [
		'#fff',
		'#ffffff',
		'#fffffe',
		'white',
	];
	const specialBorderColor = '#e1e0e0';

	return refinement?.getValues().map((refinementValue) => {
		const colorSwatch = refinementValue.getPresentationId().split('-')[0];

		if (colorSwatch) {
			const style = {
				'--color-swatch': colorSwatch,
				...(specialColorSwatchesWithBorder.includes(colorSwatch.toLowerCase())
					? {'--border-color-swatch': specialBorderColor}
					: {'--border-color-swatch': colorSwatch}),
			} as React.CSSProperties;

			return (
				<FiltersRefinementContentItem
					key={refinementValue.getKey()}
					classNames={classNames}
					style={style}
					refinementValue={refinementValue}
					split
				/>
			);
		} else {
			return null;
		}
	});
};

export default FiltersRefinementContentColorData;
